export const mergeDefaults = <
  T extends object,
  U extends { [K in keyof T]: unknown },
>(
  obj: T,
  defaults: U,
) => ({ ...defaults, ...obj });
